import React from "react";
import Modal from "../../components/Modal";
import { CheckCircleIcon, TrashIcon } from "@heroicons/react/24/outline";

const TeamMemberStatusUpdateModal = ({
  isOpen,
  onClose,
  editUserData: userObj,
  onSuccess,
  fetchTeam,
  api,
}) => {
  const handleUpdateStatus = async e => {
    try {
      e.preventDefault();

      await api.put(`/api/team/user/${userObj.id}`, {
        active: !userObj.active,
      });

      await fetchTeam();

      onSuccess();
    } catch (error) {
      alert(error.message);
    }
  };

  return (
    <Modal
      startIcon={
        userObj.active ? (
          <div className="p-2 rounded-full bg-rose-100">
            <TrashIcon className="size-6 text-rose-600" />
          </div>
        ) : (
          <div className="p-2 rounded-full bg-green-100">
            <CheckCircleIcon className="size-6 text-green-600" />
          </div>
        )
      }
      onClose={onClose}
      title={
        userObj.active ? "Deactivate team member" : "Reactivate team member"
      }
      onSubmit={handleUpdateStatus}
      open={isOpen}
      description={
        userObj.active
          ? `Are you sure you want to deactivate ${userObj.email}? They will
              lose access to there account.`
          : `Are you sure you want to reactive ${userObj.email}? They will
              regain access to there account.`
      }
    />
  );
};

export default TeamMemberStatusUpdateModal;
